"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPassReportPage = exports.DayPassReportPageActions = void 0;
var dayPassReportPageActions_1 = require("./dayPassReportPageActions");
exports.DayPassReportPageActions = dayPassReportPageActions_1.default;
var dayPassReportPage_1 = require("./dayPassReportPage");
exports.DayPassReportPage = dayPassReportPage_1.default;
